var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tooltip',{attrs:{"position":"is-left","label":_vm.$t('tooltip.sections_add')}},[_c('div',{class:this.$store.getters.sondage_results_count !== 0 ? 'isDisabled' : '',on:{"click":function($event){return _vm.addSection()}}},[_c('img',{class:this.$store.getters.sondage_results_count !== 0
          ? 'icon'
          : 'icon-disabled',attrs:{"src":require("@/assets/img/icons/add-section-icon.png"),"alt":"icon-add-section-icon"}}),_c('p',{staticStyle:{"color":"black"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8508aa62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/question/components/AddSectionQuestionButton.vue
// module id = null
// module chunks = 